import { GridColumnProps } from '@progress/kendo-react-grid'
import { NameDto } from 'api/Common/Types'
import { UserFilterKey } from 'api/Identity/Types/UserResponse'
import {
  SelectAssignTableProps,
  SelectItemEvent,
  SelectItemsEvent,
  SelectUsersAssignTable,
} from 'components/SelectOverviewTable/SelectUsersAssignTable'
import { initialState } from 'store/grid'
import { BuildQueryProps, FilterLogic } from 'utils/QueryHelpers'

export interface GridColumn extends GridColumnProps {
  width?: number
}

export type SelectTransactionsEvent = SelectItemsEvent
export type SelectTransactionEvent = SelectItemEvent

export interface SelectTicketsAssignTableProps extends Omit<SelectAssignTableProps, 'query'> {
  departments?: NameDto[]
}

export const SelectTransactionsAssignTable = (
  props: SelectTicketsAssignTableProps
): JSX.Element => {
  return <SelectUsersAssignTable {...props} query={createUsersAssignQuery()} />
}

const createUsersAssignQuery = (): BuildQueryProps => {
  const initialGridState = initialState()

  return {
    ...initialGridState.filter,
    logic: FilterLogic.AND,
    defaultFilters: {
      logic: FilterLogic.AND,
      filters: [
        {
          field: UserFilterKey.kind,
          operator: '==',
          value: 1,
        },
      ],
    },
  }
}
